module.exports = __webpack_public_path__ + "static/media/ISM-logo-380.29a63bac.png";